(() => {

    class PackAndMoveBookingCalendar {

        constructor(container) {

            this.container = container;

            this.type = container.dataset.calendarType;

            this.monthSelect =
                container.querySelector('[data-calendar-month]');

            this.yearSelect =
                container.querySelector('[data-calendar-year]');

            this.daysContainer =
                container.querySelector('[data-calendar-days]');

            this.selectedDateInput =
                container.querySelector('[data-selected-date]');

            this.today = new Date();

            this.currentMonth = this.today.getMonth();
            this.currentYear = this.today.getFullYear();

            this.selectedDate = null;

            this.minSelectableDate =
                this.normalizeDate(
                    this.getMinSelectableDate()
                );

            this.currentMonth =
                this.minSelectableDate.getMonth();

            this.currentYear =
                this.minSelectableDate.getFullYear();

            this.init();

            this.container.__calendarInstance = this;

            this.observeVisibility();

        }


        /*
        |--------------------------------------------------------------------------
        | Normalize Date
        |--------------------------------------------------------------------------
        */

        normalizeDate(value) {

            const date =
                value instanceof Date
                    ? new Date(value)
                    : new Date(value);

            if (Number.isNaN(date.getTime())) {

                const fallback =
                    new Date(this.today);

                fallback.setHours(
                    0,
                    0,
                    0,
                    0
                );

                return fallback;

            }

            date.setHours(
                0,
                0,
                0,
                0
            );

            return date;

        }


        /*
        |--------------------------------------------------------------------------
        | Get Minimum Selectable Date
        |--------------------------------------------------------------------------
        */

        getMinSelectableDate() {

            /*
            |--------------------------------------------------------------------------
            | Container Collection Calendar
            |
            | Depends on Move Date.
            |
            | Move Date itself is NOT counted.
            | Next working day = Day 1.
            | First 7 working days are complimentary.
            |--------------------------------------------------------------------------
            */

            if (
                this.type === "container_collection"
            ) {

                const moveDate =
                    (
                        window.packAndMoveBooking?.move?.date ||
                        window.packAndMoveBooking?.collectionDate
                    );

                if (moveDate) {

                    const date =
                        new Date(moveDate);

                    date.setHours(
                        0,
                        0,
                        0,
                        0
                    );

                    let businessDays = 0;

                    while (
                        businessDays < 7
                    ) {

                        date.setDate(
                            date.getDate() + 1
                        );

                        const day =
                            date.getDay();

                        if (
                            day !== 0 &&
                            day !== 6
                        ) {

                            businessDays++;

                        }

                    }

                    return date;

                }


                /*
                |--------------------------------------------------------------------------
                | No Move Date selected yet
                |--------------------------------------------------------------------------
                */

                const date =
                    new Date(this.today);

                date.setHours(
                    0,
                    0,
                    0,
                    0
                );

                return date;

            }


            /*
            |--------------------------------------------------------------------------
            | Move Date / Collection Calendar
            |--------------------------------------------------------------------------
            */

            if (
                this.type === "collection"
            ) {

                const delivery =
                    (
                        window.packAndMoveBooking?.delivery?.date ||
                        window.packAndMoveBooking?.deliveryDate
                    );

                if (delivery) {

                    const date =
                        new Date(delivery);

                    date.setHours(
                        0,
                        0,
                        0,
                        0
                    );

                    let businessDays = 0;

                    const leadBusinessDays =
                        parseInt(
                            this.container.dataset.leadBusinessDays,
                            10
                        ) || 3;

                    while (
                        businessDays < leadBusinessDays
                    ) {

                        date.setDate(
                            date.getDate() + 1
                        );

                        const day =
                            date.getDay();

                        if (
                            day !== 0 &&
                            day !== 6
                        ) {

                            businessDays++;

                        }

                    }

                    return date;

                }

            }


            /*
            |--------------------------------------------------------------------------
            | Delivery Calendar
            |--------------------------------------------------------------------------
            */

            const date =
                new Date(this.today);

            date.setHours(
                0,
                0,
                0,
                0
            );

            let businessDays = 0;

            const leadBusinessDays =
                parseInt(
                    this.container.dataset.leadBusinessDays,
                    10
                ) || 3;

            while (
                businessDays < leadBusinessDays
            ) {

                date.setDate(
                    date.getDate() + 1
                );

                const day =
                    date.getDay();

                if (
                    day !== 0 &&
                    day !== 6
                ) {

                    businessDays++;

                }

            }

            return date;

        }


        /*
        |--------------------------------------------------------------------------
        | Calculate Extended Rental Days
        |--------------------------------------------------------------------------
        */

        calculateExtendedRentalDays(
            collectionDate
        ) {

            if (
                this.type !== "container_collection" ||
                !collectionDate
            ) {

                return 0;

            }

            const moveDate =
                (
                    window.packAndMoveBooking?.move?.date ||
                    window.packAndMoveBooking?.collectionDate
                );

            if (!moveDate) {

                return 0;

            }

            const move =
                new Date(moveDate);

            move.setHours(
                0,
                0,
                0,
                0
            );

            const collection =
                new Date(collectionDate);

            collection.setHours(
                0,
                0,
                0,
                0
            );


            /*
            |--------------------------------------------------------------------------
            | Calculate the end of the 7 complimentary working days
            |--------------------------------------------------------------------------
            */

            const complimentaryEnd =
                new Date(move);

            let businessDays = 0;

            while (
                businessDays < 7
            ) {

                complimentaryEnd.setDate(
                    complimentaryEnd.getDate() + 1
                );

                const day =
                    complimentaryEnd.getDay();

                if (
                    day !== 0 &&
                    day !== 6
                ) {

                    businessDays++;

                }

            }


            /*
            |--------------------------------------------------------------------------
            | Collection within complimentary period
            |--------------------------------------------------------------------------
            */

            if (
                collection <= complimentaryEnd
            ) {

                return 0;

            }


            /*
            |--------------------------------------------------------------------------
            | Extended rental starts after the
            | 7th complimentary working day.
            |
            | Extended rental is charged per calendar day.
            |--------------------------------------------------------------------------
            */

            const difference =
                collection.getTime() -
                complimentaryEnd.getTime();

            return Math.ceil(
                difference /
                (1000 * 60 * 60 * 24)
            );

        }


        /*
        |--------------------------------------------------------------------------
        | Initialise
        |--------------------------------------------------------------------------
        */

        init() {

            this.populateSelectors();

            this.bindEvents();

            this.renderCalendar();

            this.updateSelectedDateDisplay();

        }


        /*
        |--------------------------------------------------------------------------
        | Observe Step Visibility
        |--------------------------------------------------------------------------
        */

        observeVisibility() {

            const step =
                this.container.closest(
                    ".pack-and-move-step"
                );

            if (!step) {

                return;

            }

            const observer =
                new MutationObserver(() => {

                    if (!step.hidden) {

                        if (
                            this.type === "container_collection" &&
                            (
                                window.packAndMoveBooking?.move?.date ||
                                window.packAndMoveBooking?.collectionDate
                            )
                        ) {

                            this.refreshFromDependency();

                        }

                    }

                });

            observer.observe(
                step,
                {
                    attributes: true,
                    attributeFilter: [
                        "hidden"
                    ]
                }
            );

        }


        /*
        |--------------------------------------------------------------------------
        | Refresh From Dependency
        |--------------------------------------------------------------------------
        */

        refreshFromDependency() {

            this.minSelectableDate =
                this.normalizeDate(
                    this.getMinSelectableDate()
                );

            this.currentMonth =
                this.minSelectableDate.getMonth();

            this.currentYear =
                this.minSelectableDate.getFullYear();

            this.selectedDate = null;

            this.populateSelectors();

            this.renderCalendar();

            this.updateSelectedDateDisplay();

        }


        /*
        |--------------------------------------------------------------------------
        | Populate Month / Year Selectors
        |--------------------------------------------------------------------------
        */

        populateSelectors() {

            if (this.monthSelect) {

                this.monthSelect.value =
                    this.currentMonth;

            }

            if (this.yearSelect) {

                this.yearSelect.value =
                    this.currentYear;

            }

        }


        /*
        |--------------------------------------------------------------------------
        | Bind Events
        |--------------------------------------------------------------------------
        */

        bindEvents() {

            if (this.monthSelect) {

                this.monthSelect.addEventListener(
                    "change",
                    () => {

                        this.currentMonth =
                            parseInt(
                                this.monthSelect.value,
                                10
                            );

                        this.renderCalendar();

                    }
                );

            }


            if (this.yearSelect) {

                this.yearSelect.addEventListener(
                    "change",
                    () => {

                        this.currentYear =
                            parseInt(
                                this.yearSelect.value,
                                10
                            );

                        this.renderCalendar();

                    }
                );

            }

        }


        /*
        |--------------------------------------------------------------------------
        | Render Calendar
        |--------------------------------------------------------------------------
        */

        renderCalendar() {

            if (!this.daysContainer) {

                return;

            }

            this.daysContainer.innerHTML = "";

            const firstDay =
                new Date(
                    this.currentYear,
                    this.currentMonth,
                    1
                );

            const lastDay =
                new Date(
                    this.currentYear,
                    this.currentMonth + 1,
                    0
                );

            const totalDays =
                lastDay.getDate();

            let startDay =
                firstDay.getDay();

            startDay =
                startDay === 0
                    ? 6
                    : startDay - 1;


            /*
            |--------------------------------------------------------------------------
            | Empty Cells Before First Day
            |--------------------------------------------------------------------------
            */

            for (
                let i = 0;
                i < startDay;
                i++
            ) {

                const empty =
                    document.createElement("div");

                empty.className =
                    "pack-and-move-calendar-day pack-and-move-calendar-day--empty";

                this.daysContainer.appendChild(
                    empty
                );

            }


            /*
            |--------------------------------------------------------------------------
            | Calendar Days
            |--------------------------------------------------------------------------
            */

            for (
                let day = 1;
                day <= totalDays;
                day++
            ) {

                const button =
                    document.createElement("button");

                button.type =
                    "button";

                button.className =
                    "pack-and-move-calendar-day";

                button.textContent =
                    day;


                const date =
                    new Date(
                        this.currentYear,
                        this.currentMonth,
                        day
                    );

                date.setHours(
                    0,
                    0,
                    0,
                    0
                );


                /*
                |--------------------------------------------------------------------------
                | Selected Date
                |--------------------------------------------------------------------------
                */

                if (
                    this.selectedDate &&
                    date.toDateString() ===
                    this.selectedDate.toDateString()
                ) {

                    button.classList.add(
                        "pack-and-move-calendar-day--selected"
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | Disable Weekends
                |--------------------------------------------------------------------------
                */

                const isWeekend =
                    date.getDay() === 0 ||
                    date.getDay() === 6;


                /*
                |--------------------------------------------------------------------------
                | Disable Dates Before Minimum Date
                |--------------------------------------------------------------------------
                */

                const isBeforeMin =
                    date.getTime() <
                    this.minSelectableDate.getTime();


                if (
                    isWeekend ||
                    isBeforeMin
                ) {

                    button.disabled =
                        true;

                    button.classList.add(
                        "pack-and-move-calendar-day--disabled"
                    );

                }

                else {

                    button.addEventListener(
                        "click",
                        () => {

                            this.selectedDate =
                                new Date(date);


                            window.packAndMoveBooking =
                                window.packAndMoveBooking || {};


                            /*
                            |--------------------------------------------------------------------------
                            | DELIVERY DATE
                            |--------------------------------------------------------------------------
                            */

                            if (
                                this.type === "delivery"
                            ) {

                                window.packAndMoveBooking.delivery =
                                    window.packAndMoveBooking.delivery || {};

                                window.packAndMoveBooking.delivery.date =
                                    new Date(
                                        this.selectedDate
                                    );

                                /*
                                |--------------------------------------------------------------------------
                                | Keep flat alias for compatibility
                                |--------------------------------------------------------------------------
                                */

                                window.packAndMoveBooking.deliveryDate =
                                    new Date(
                                        this.selectedDate
                                    );

                            }


                            /*
                            |--------------------------------------------------------------------------
                            | MOVE DATE
                            |--------------------------------------------------------------------------
                            */

                            else if (
                                this.type === "collection"
                            ) {

                                window.packAndMoveBooking.move =
                                    window.packAndMoveBooking.move || {};

                                window.packAndMoveBooking.move.date =
                                    new Date(
                                        this.selectedDate
                                    );

                                /*
                                |--------------------------------------------------------------------------
                                | Keep flat alias for compatibility
                                |--------------------------------------------------------------------------
                                */

                                window.packAndMoveBooking.collectionDate =
                                    new Date(
                                        this.selectedDate
                                    );

                            }


                            /*
                            |--------------------------------------------------------------------------
                            | CONTAINER COLLECTION DATE
                            |--------------------------------------------------------------------------
                            */

                            else if (
                                this.type === "container_collection"
                            ) {

                                window.packAndMoveBooking.containerCollectionDate =
                                    new Date(
                                        this.selectedDate
                                    );


                                const extendedRentalDays =
                                    this.calculateExtendedRentalDays(
                                        this.selectedDate
                                    );


                                window.packAndMoveBooking.extendedRentalDays =
                                    extendedRentalDays;


                                window.packAndMoveBooking.extendedRentalRate =
                                    10;


                                window.packAndMoveBooking.extendedRentalPrice =
                                    extendedRentalDays * 10;

                            }


                            /*
                            |--------------------------------------------------------------------------
                            | Refresh Dependent Calendars
                            |--------------------------------------------------------------------------
                            */

                            document
                                .querySelectorAll(
                                    ".pack-and-move-booking-calendar"
                                )
                                .forEach(
                                    calendar => {

                                        if (
                                            !calendar.__calendarInstance
                                        ) {

                                            return;

                                        }

                                        const dependentCalendar =
                                            calendar.__calendarInstance;

                                        const dependsOn =
                                            dependentCalendar
                                                .container
                                                .dataset
                                                .dependsOn;


                                        /*
                                        |--------------------------------------------------------------------------
                                        | Delivery → Move Date
                                        |--------------------------------------------------------------------------
                                        */

                                        if (
                                            this.type === "delivery" &&
                                            dependsOn === "delivery"
                                        ) {

                                            dependentCalendar
                                                .minSelectableDate =
                                                    dependentCalendar
                                                        .normalizeDate(
                                                            dependentCalendar
                                                                .getMinSelectableDate()
                                                        );

                                            dependentCalendar
                                                .currentMonth =
                                                    dependentCalendar
                                                        .minSelectableDate
                                                        .getMonth();

                                            dependentCalendar
                                                .currentYear =
                                                    dependentCalendar
                                                        .minSelectableDate
                                                        .getFullYear();

                                            dependentCalendar
                                                .selectedDate =
                                                    null;

                                            dependentCalendar
                                                .populateSelectors();

                                            dependentCalendar
                                                .renderCalendar();

                                            dependentCalendar
                                                .updateSelectedDateDisplay();

                                        }


                                        /*
                                        |--------------------------------------------------------------------------
                                        | Move Date → Container Collection
                                        |--------------------------------------------------------------------------
                                        */

                                        if (
                                            this.type === "collection" &&
                                            dependsOn === "move"
                                        ) {

                                            dependentCalendar
                                                .minSelectableDate =
                                                    dependentCalendar
                                                        .normalizeDate(
                                                            dependentCalendar
                                                                .getMinSelectableDate()
                                                        );

                                            dependentCalendar
                                                .currentMonth =
                                                    dependentCalendar
                                                        .minSelectableDate
                                                        .getMonth();

                                            dependentCalendar
                                                .currentYear =
                                                    dependentCalendar
                                                        .minSelectableDate
                                                        .getFullYear();

                                            dependentCalendar
                                                .selectedDate =
                                                    null;

                                            dependentCalendar
                                                .populateSelectors();

                                            dependentCalendar
                                                .renderCalendar();

                                            dependentCalendar
                                                .updateSelectedDateDisplay();

                                        }

                                    }
                                );


                            /*
                            |--------------------------------------------------------------------------
                            | Update Selected Display
                            |--------------------------------------------------------------------------
                            */

                            this.updateSelectedDateDisplay();


                            /*
                            |--------------------------------------------------------------------------
                            | Re-render Current Calendar
                            |--------------------------------------------------------------------------
                            */

                            this.renderCalendar();


                            /*
                            |--------------------------------------------------------------------------
                            | Format Selected Date
                            |--------------------------------------------------------------------------
                            */

                            const formatted =
                                this.selectedDate
                                    .toLocaleDateString(
                                        "en-SG",
                                        {
                                            day: "numeric",
                                            month: "long",
                                            year: "numeric"
                                        }
                                    );


                            /*
                            |--------------------------------------------------------------------------
                            | Dispatch calendar:selected Event
                            |--------------------------------------------------------------------------
                            */

                            this.container.dispatchEvent(
                                new CustomEvent(
                                    "calendar:selected",
                                    {
                                        bubbles: true,

                                        detail: {

                                            date:
                                                formatted,

                                            rawDate:
                                                this.selectedDate,

                                            type:
                                                this.type,

                                            extendedRentalDays:
                                                window
                                                    .packAndMoveBooking
                                                    ?.extendedRentalDays || 0,

                                            extendedRentalRate:
                                                window
                                                    .packAndMoveBooking
                                                    ?.extendedRentalRate || 0,

                                            extendedRentalPrice:
                                                window
                                                    .packAndMoveBooking
                                                    ?.extendedRentalPrice || 0

                                        }

                                    }
                                )
                            );

                        }
                    );

                }


                this.daysContainer.appendChild(
                    button
                );

            }

        }


        /*
        |--------------------------------------------------------------------------
        | Update Selected Date Display
        |--------------------------------------------------------------------------
        */

        updateSelectedDateDisplay() {

            const heading =
                this.container.querySelector(
                    "[data-selected-heading]"
                );


            /*
            |--------------------------------------------------------------------------
            | No Date Selected
            |--------------------------------------------------------------------------
            */

            if (!this.selectedDate) {

                if (heading) {

                    if (
                        this.type === "container_collection"
                    ) {

                        heading.textContent =
                            "Select Container Collection Date";

                    }

                    else if (
                        this.type === "collection"
                    ) {

                        heading.textContent =
                            "Select Collection Date";

                    }

                    else {

                        heading.textContent =
                            "Select Delivery Date";

                    }

                }


                if (this.selectedDateInput) {

                    this.selectedDateInput.value =
                        "";

                }

                return;

            }


            /*
            |--------------------------------------------------------------------------
            | Selected Date
            |--------------------------------------------------------------------------
            */

            const formatted =
                this.selectedDate
                    .toLocaleDateString(
                        "en-SG",
                        {
                            day: "numeric",
                            month: "long",
                            year: "numeric"
                        }
                    );


            if (heading) {

                heading.textContent =
                    formatted;

            }


            if (this.selectedDateInput) {

                this.selectedDateInput.value =
                    formatted;

            }

        }

    }


    /*
    |--------------------------------------------------------------------------
    | Initialise All Calendars
    |--------------------------------------------------------------------------
    */

    document.addEventListener(
        "DOMContentLoaded",
        () => {

            document
                .querySelectorAll(
                    ".pack-and-move-booking-calendar"
                )
                .forEach(
                    calendar => {

                        new PackAndMoveBookingCalendar(
                            calendar
                        );

                    }
                );

        }
    );

})();